export const LOCALOPS_OPS_ROUTE = '/localops/ops';
export const LOCALOPS_OPS_LAST_TASK_ID_KEY = 'localopsOps:lastTaskId';

export function getLocalOpsOpsPlayerRecord(player) {
  return player?.data?.player || player?.player || player || null;
}

export function canViewLocalOpsOps(player) {
  const record = getLocalOpsOpsPlayerRecord(player);
  if (!record) return false;

  const role = String(record.role || '').trim();

  return role === 'admin';
}
